import { Field, Image, ImageField, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { ComponentProps, resolveBackgroundStyle } from '@gn-audio/jss-components';

export type SingleImageSpotFields = {
  desktopImage: ImageField;
  mobileImage: ImageField;
  isFullWidth: Field<boolean>;
  background: Field<string>;
};

type SingleImageSpotProps = {
  fields: SingleImageSpotFields;
} & ComponentProps;

const SingleImageSpot = ({
  fields: { desktopImage, mobileImage, isFullWidth, background },
}: SingleImageSpotProps) => {
  const containerClass = isFullWidth?.value ? 'container-fluid' : 'container';
  const borderRadiusClass = isFullWidth?.value ? 'rounded-none' : 'rounded-2xl overflow-hidden';
  const spotBackgroundStyle = resolveBackgroundStyle(background?.value as string);

  if (!desktopImage?.value?.src && !mobileImage?.value?.src) {
    return null;
  }

  return (
    <div style={spotBackgroundStyle}>
      <div className={classNames('flex justify-center', containerClass)}>
        <picture className={borderRadiusClass}>
          <source
            media="(max-width: 991px)"
            srcSet={mobileImage?.value?.src || desktopImage?.value?.src}
          />
          <Image field={desktopImage} className="h-auto max-w-full object-contain" loading="lazy" />
        </picture>
      </div>
    </div>
  );
};

export default withDatasourceCheck()(SingleImageSpot);
